module.exports = __webpack_public_path__ + "img/local_movies.cf19ca8a.svg";